import React, { useState, useEffect } from "react";
import "../../css/CRUDModal.css";
import {apiList, baseAuthUrl, baseUrl} from "../../helpers/apiList";
import axios from "axios";
import CustomAlert from "../../helpers/CustomAlert";
import { axiosPostApi } from "../../helpers/interceptorServices";
import AddVectorIcon from "../../../src/assets/Icons/Add Vector.png";
import CrossIcon from "../../assets/Icons/cross_svg.svg";
import LeftCircle from "../../assets/Icons/Left circle B.png";
import RightCircle from "../../assets/Icons/Right circle A.png";
import { useSelector } from "react-redux";

const AddPickupAddressModal = ({
  show,
  handleClose,
  callApi,
  editData,
  action,
  columnData,
}) => {
  const loggedInUserName = sessionStorage.getItem("username");

  const [formData, setFormData] = useState({
    addressTitle: "",
    addressee: "",
    fullAddress: "",
    phone: "",
    pinCode: "",
    city: "",
    state: "",
    email: "",
    optnAddressId: "",
    status: "ACTIVE",
  });

  const [errors, setErrors] = useState({
    addressTitle: "",
    addressee: "",
    fullAddress: "",
    phone: "",
    pinCode: "",
    city: "",
    state: "",
    email: "",
  });

  const { userProfile } = useSelector((state) => state.auth);

  useEffect(() => {
    if (action === "add") {
      setFormData({
        addressTitle: "",
        addressee: "",
        fullAddress: "",
        phone: "",
        pinCode: "",
        city: "",
        state: "",
        email: "",
        optnAddressId: "",
        status: "ACTIVE",
      });
    } else if (action === "modify" || action === "view") {
      setFormData({
        ...editData,
        addressTitle: columnData?.addressTitle || "",
        addressee: columnData?.addressee || "",
        fullAddress: columnData?.fullAddress || "",
        phone: columnData?.phone || "",
        pinCode: columnData?.pinCode || "",
        city: columnData?.city || "",
        state: columnData?.state || "",
        email: columnData?.email || "",
        optnAddressId: columnData?.optnAddressId || "",
        status: columnData?.status || "ACTIVE",
      });
    }
    setErrors({
      addressTitle: "",
      addressee: "",
      fullAddress: "",
      phone: "",
      pinCode: "",
      city: "",
      state: "",
      email: "",
    });
  }, [show, action, editData, columnData]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    let updatedValue = value;

    // Initialize field-specific errors
    let fieldErrors = { ...errors };

    // Handle field-specific input restrictions and validation
    if (id === "phone") {
      updatedValue = value.replace(/[^0-9]/g, "");

      if (!updatedValue) {
        fieldErrors.phone = "Mobile number is required";
      } else if (!/^[6-9]\d{9}$/.test(updatedValue)) {
        fieldErrors.phone =
          "Mobile number must be 10 digits and start with 6, 7, 8, or 9";
      } else if (/^([0-9])\1{9}$/.test(updatedValue)) {
        fieldErrors.phone = "Mobile number cannot have all digits the same";
      } else {
        fieldErrors.phone = "";
      }
    } else if (id === "pinCode") {
      updatedValue = value.replace(/[^0-9]/g, "");
      if (!updatedValue) {
        fieldErrors.pinCode = "Pincode is required";
      } else if (!/^[1-9]\d{5}$/.test(updatedValue)) {
        fieldErrors.pinCode = "Pincode must be 6 digits and not start with 0";
      } else {
        fieldErrors.pinCode = "";
      }
    } else if (id === "addressee") {
      if (/^[A-Za-z .'-]*$/.test(value)) {
        updatedValue = value;
        const trimmedValue = updatedValue.trim();
        if (!trimmedValue) {
          fieldErrors.addressee = "Addressee is required";
        } else if (updatedValue !== updatedValue.trim()) {
          fieldErrors.addressee = "No leading or trailing spaces";
        } else if (!/^[A-Za-z]/.test(trimmedValue)) {
          fieldErrors.addressee = "Must start with a letter";
        } else if (trimmedValue.length < 2 || trimmedValue.length > 50) {
          fieldErrors.addressee = "Must be 2-50 characters";
        } else if (/\s{2,}/.test(trimmedValue)) {
          fieldErrors.addressee = "No multiple consecutive spaces";
        } else if (!/^[A-Za-z .'-]+$/.test(trimmedValue)) {
          fieldErrors.addressee =
            "Should contain only alphabetic characters, spaces, hyphens, apostrophes, and periods";
        } else {
          fieldErrors.addressee = "";
        }
      } else {
        return;
      }
    } else if (id === "addressTitle") {
      updatedValue = value;
      const trimmedValue = updatedValue.trim();
      if (!trimmedValue) {
        fieldErrors.addressTitle = "Address title is required";
      } else if (trimmedValue.length < 3 || trimmedValue.length > 50) {
        fieldErrors.addressTitle =
          "Address title must be between 3 and 50 characters";
      } else if (!/^[A-Za-z][A-Za-z0-9 _'-]*$/.test(trimmedValue)) {
        fieldErrors.addressTitle =
          "Address title must contain only letters, numbers, spaces, hyphens (-), underscores (_), and apostrophes (') and must start with a letter";
      } else {
        fieldErrors.addressTitle = "";
      }
    } else if (id === "fullAddress") {
      updatedValue = value;
      const trimmedValue = updatedValue.trim();
      if (!trimmedValue) {
        fieldErrors.fullAddress = "Full address is required";
      } else if (trimmedValue.length < 10 || trimmedValue.length > 200) {
        fieldErrors.fullAddress =
          "Full address must be between 10 and 200 characters";
      } else if (
        !/^[A-Za-z0-9][A-Za-z0-9 ,.'\/#-]*[A-Za-z0-9,'.\/#-]$/.test(
          updatedValue
        )
      ) {
        fieldErrors.fullAddress =
          "Full address contains invalid characters, starts/ends with spaces, or does not start with a letter or number";
      } else {
        fieldErrors.fullAddress = "";
      }
    } else if (id === "email") {
      updatedValue = value;
      if (!updatedValue) {
        fieldErrors.email = "Email is required";
      } else if (
        !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(com|in|pe|co\.[a-zA-Z]{2})$/.test(
          updatedValue
        ) ||
        /\.com\./.test(updatedValue) ||
        /\.co\.[a-zA-Z]{2}\./.test(updatedValue)
      ) {
        fieldErrors.email =
          "Enter valid email ending with .com, .in, .pe, or .co.xx";
      } else {
        fieldErrors.email = "";
      }
    } else if (
      id === "optnAddressId" &&
      userProfile === "OPERATION" &&
      action === "modify"
    ) {
      // Allow only numeric values
      updatedValue = value.replace(/[^0-9]/g, "");
      if (!updatedValue) {
        fieldErrors.optnAddressId = "Address ID is required";
      } else if (!/^\d+$/.test(updatedValue)) {
        fieldErrors.optnAddressId = "Address ID must contain only numbers";
      } else if (updatedValue.length > 5) {
        fieldErrors.optnAddressId = "Address ID must be at most 5 digits";
      } else if (value !== value.trim()) {
        fieldErrors.optnAddressId = "No leading or trailing spaces";
      } else {
        fieldErrors.optnAddressId = "";
      }
    }

    // Update form data
    setFormData((prev) => ({
      ...prev,
      [id]: updatedValue,
    }));

    // Update errors
    setErrors(fieldErrors);

    // Trigger pinCode API validation if pinCode changes
    if (id === "pinCode") {
      validatePinCode(updatedValue);
    }
  };

  const validate = () => {
    const newErrors = {};

    // Address Title validation
    const trimmedTitle = formData.addressTitle.trim();
    if (!trimmedTitle) {
      newErrors.addressTitle = "Address title is required";
    } else if (trimmedTitle.length < 3 || trimmedTitle.length > 50) {
      newErrors.addressTitle =
        "Address title must be between 3 and 50 characters";
    } else if (!/^[A-Za-z][A-Za-z0-9 _'-]*$/.test(trimmedTitle)) {
      newErrors.addressTitle =
        "Address title must contain only letters, numbers, spaces, hyphens (-), underscores (_), and apostrophes (') and must start with a letter";
    }

    // Addressee validation
    const trimmedAddressee = formData.addressee.trim();
    if (!trimmedAddressee) {
      newErrors.addressee = "Addressee is required";
    } else if (formData.addressee !== formData.addressee.trim()) {
      newErrors.addressee = "No leading or trailing spaces";
    } else if (!/^[A-Za-z]/.test(trimmedAddressee)) {
      newErrors.addressee = "Must start with a letter";
    } else if (trimmedAddressee.length < 2 || trimmedAddressee.length > 50) {
      newErrors.addressee = "Must be 2-50 characters";
    } else if (/\s{2,}/.test(trimmedAddressee)) {
      newErrors.addressee = "No multiple consecutive spaces";
    } else if (!/^[A-Za-z .'-]+$/.test(trimmedAddressee)) {
      newErrors.addressee =
        "Should contain only alphabetic characters, spaces, hyphens, apostrophes, and periods";
    }

    // Full Address validation
    if (!formData.fullAddress) {
      newErrors.fullAddress = "Full address is required";
    } else {
      const trimmedFullAddress = formData.fullAddress.trim();
      if (trimmedFullAddress.length < 10 || trimmedFullAddress.length > 200) {
        newErrors.fullAddress =
          "Full address must be between 10 and 200 characters";
      } else if (
        !/^[A-Za-z0-9][A-Za-z0-9 ,.'\/#-]*[A-Za-z0-9,'.\/#-]$/.test(
          formData.fullAddress
        )
      ) {
        newErrors.fullAddress =
          "Full address contains invalid characters, starts/ends with spaces, or does not start with a letter or number";
      }
    }

    // Phone validation
    if (!formData.phone) {
      newErrors.phone = "Mobile number is required";
    } else if (!/^[6-9]\d{9}$/.test(formData.phone)) {
      newErrors.phone =
        "Mobile number must be 10 digits and start with 6, 7, 8, or 9";
    } else if (/^([0-9])\1{9}$/.test(formData.phone)) {
      newErrors.phone = "Mobile number cannot have all digits the same";
    }

    // Pincode validation
    if (!formData.pinCode) {
      newErrors.pinCode = "Pincode is required";
    } else if (!/^[1-9]\d{5}$/.test(formData.pinCode)) {
      newErrors.pinCode = "Pincode must be 6 digits and not start with 0";
    }

    // City validation
    if (!formData.city) {
      newErrors.city = "City is required";
    }

    // State validation
    if (!formData.state) {
      newErrors.state = "State is required";
    }

    // Email validation
    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(com|in|pe|co\.[a-zA-Z]{2})$/.test(
        formData.email
      ) ||
      /\.com\./.test(formData.email) ||
      /\.co\.[a-zA-Z]{2}\./.test(formData.email)
    ) {
      newErrors.email =
        "Enter valid email ending with .com, .in, .pe, or .co.xx";
    }

    // Address ID (optnAddressId) validation
    if (userProfile === "OPERATION" && action === "modify") {
      if (!formData.optnAddressId) {
        newErrors.optnAddressId = "Address ID is required";
      } else {
        const trimmedOptnAddressId = formData.optnAddressId.trim();
        if (!/^\d+$/.test(trimmedOptnAddressId)) {
          newErrors.optnAddressId = "Address ID must contain only numbers";
        } else if (trimmedOptnAddressId.length > 5) {
          newErrors.optnAddressId = "Address ID must be between 1 and 5 digits";
        } else if (formData.optnAddressId !== trimmedOptnAddressId) {
          newErrors.optnAddressId = "No leading or trailing spaces";
        }
      }
    }

    return newErrors;
  };

  const handleBlur = (e) => {
    const { id, value } = e.target;
    const fieldErrors = {};
    const trimmedValue = value?.trim();

    switch (id) {
      case "addressTitle":
        if (!trimmedValue) {
          fieldErrors.addressTitle = "Address title is required";
        } else if (trimmedValue.length < 3 || trimmedValue.length > 50) {
          fieldErrors.addressTitle =
            "Address title must be between 3 and 50 characters";
        } else if (!/^[A-Za-z][A-Za-z0-9 _'-]*$/.test(trimmedValue)) {
          fieldErrors.addressTitle =
            "Address title must contain only letters, numbers, spaces, hyphens (-), underscores (_), and apostrophes (') and must start with a letter";
        }
        break;

      case "addressee":
        if (!trimmedValue) {
          fieldErrors.addressee = "Addressee is required";
        } else if (value !== value.trim()) {
          fieldErrors.addressee = "No leading or trailing spaces";
        } else if (!/^[A-Za-z]/.test(trimmedValue)) {
          fieldErrors.addressee = "Must start with a letter";
        } else if (trimmedValue.length < 2 || trimmedValue.length > 50) {
          fieldErrors.addressee = "Must be 2-50 characters";
        } else if (/\s{2,}/.test(trimmedValue)) {
          fieldErrors.addressee = "No multiple consecutive spaces";
        } else if (!/^[A-Za-z .'-]+$/.test(trimmedValue)) {
          fieldErrors.addressee =
            "Should contain only alphabetic characters, spaces, hyphens, apostrophes, and periods";
        }
        break;

      case "fullAddress":
        if (!trimmedValue) {
          fieldErrors.fullAddress = "Full address is required";
        } else if (trimmedValue.length < 10 || trimmedValue.length > 200) {
          fieldErrors.fullAddress =
            "Full address must be between 10 and 200 characters";
        } else if (
          !/^[A-Za-z0-9][A-Za-z0-9 ,.'\/#-]*[A-Za-z0-9,'.\/#-]$/.test(value)
        ) {
          fieldErrors.fullAddress =
            "Full address contains invalid characters, starts/ends with spaces, or does not start with a letter or number";
        }
        break;

      case "phone":
        if (!trimmedValue) {
          fieldErrors.phone = "Mobile number is required";
        } else if (!/^[6-9]\d{9}$/.test(trimmedValue)) {
          fieldErrors.phone =
            "Mobile number must be 10 digits and start with 6, 7, 8, or 9";
        } else if (/^([0-9])\1{9}$/.test(trimmedValue)) {
          fieldErrors.phone = "Mobile number cannot have all digits the same";
        }
        break;

      case "pinCode":
        if (!trimmedValue) {
          fieldErrors.pinCode = "Pincode is required";
        } else if (!/^[1-9]\d{5}$/.test(trimmedValue)) {
          fieldErrors.pinCode =
            "Pincode must be 6 digits and must not start with 0";
        }
        break;

      case "state":
        if (!trimmedValue) {
          fieldErrors.state = "State is required";
        }
        break;

      case "email":
        if (!trimmedValue) {
          fieldErrors.email = "Email is required";
        } else if (
          !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(com|in|pe|co\.[a-zA-Z]{2})$/.test(
            trimmedValue
          ) ||
          /\.com\./.test(trimmedValue) ||
          /\.co\.[a-zA-Z]{2}\./.test(trimmedValue)
        ) {
          fieldErrors.email =
            "Enter valid email ending with .com, .in, .pe, or .co.xx";
        }
        break;

      case "optnAddressId":
        if (userProfile === "OPERATION" && action === "modify") {
          if (!trimmedValue) {
            fieldErrors.optnAddressId = "Address ID is required";
          } else if (!/^\d+$/.test(trimmedValue)) {
            fieldErrors.optnAddressId = "Address ID must contain only numbers";
          } else if (trimmedValue.length > 5) {
            fieldErrors.optnAddressId =
              "Address ID must be between 1 and 5 digits";
          } else if (value !== value?.trim()) {
            fieldErrors.optnAddressId = "No leading or trailing spaces";
          }
        }
        break;

      default:
        break;
    }

    setErrors((prev) => ({
      ...prev,
      ...fieldErrors,
    }));
  };

  const validatePinCode = (pinCode) => {
    let newErrors = { ...errors };

    if (!pinCode) {
      newErrors.pinCode = "Pincode is required";
    } else if (!/^\d{6}$/.test(pinCode)) {
      newErrors.pinCode = "Pincode must be 6 digits";
    } else {
      delete newErrors.pinCode;

      axios
        .get(`${baseAuthUrl}/sms/pincode/${pinCode}`)
        .then((response) => {
          const { status, message, data } = response.data;

          if (!status || !data || data.length === 0) {
            newErrors.pinCode = message || "Enter a valid Pincode";
            setFormData((prevFormData) => ({
              ...prevFormData,
              city: "",
              state: "",
            }));
          } else {
            const pinCodeData = data[0];
            const { cityName, state } = pinCodeData;
            setFormData((prevFormData) => ({
              ...prevFormData,
              city: cityName,
              state,
            }));
            delete newErrors.city;
            delete newErrors.state;
          }
          setErrors(newErrors);
        })
        .catch((error) => {
          console.error("Error fetching pincode data:", error);
          newErrors.pinCode = "Error fetching pincode data";
          setFormData((prevFormData) => ({
            ...prevFormData,
            city: "",
            state: "",
          }));
          setErrors(newErrors);
        });
    }
  };

  const isViewMode = action === "view";
  const isReadOnly = isViewMode;

  const handleBack = () => {
    handleClose();
    setErrors({});
  };

  const handleAddPickupAddressModal = () => {
    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      let apiUrl = "";
      if (action === "add") {
        apiUrl = apiList.CREATE_PICKUPADDRESS;
      } else if (action === "modify") {
        apiUrl = apiList.MODIFY_PICKUPADDRESS;
      } else {
        return;
      }

      const payload = {
        username: loggedInUserName,
        ...(action === "modify" && {
          addressId: columnData?.addressId || columnData?.id,
          optnAddressId: formData.optnAddressId || undefined,
        }),
        addressTitle: formData.addressTitle || undefined,
        addressee: formData.addressee || undefined,
        fullAddress: formData.fullAddress || undefined,
        phone: formData.phone || undefined,
        pinCode: formData.pinCode || undefined,
        city: formData.city || undefined,
        state: formData.state || undefined,
        email: formData.email || undefined,
        status: formData.status || "ACTIVE",
      };

      axiosPostApi(apiUrl, payload)
        .then((response) => {
          if (response?.status === 200 && response?.data?.status === true) {
            CustomAlert({
              title: response?.data?.message,
              icon: "success",
              confirmButtonText: "OK",
              showCloseButton: true,
              allowOutsideClick: false,
            });
            callApi(1);
            handleClose();
          } else if (response?.status === 200 && !response?.data?.status) {
            CustomAlert({
              title: "Failed to Request",
              text: response.data.message,
              icon: "error",
              confirmButtonText: "Retry",
            });
          }

          if (response?.data?.respCode === "02") {
            CustomAlert({
              title: "Warning",
              text:
                response?.data?.message || "Unable to proceed, Request again",
              icon: "warning",
              confirmButtonText: "Okay",
            });
          }
        })
        .catch((error) => {
          console.error("Error processing request:", error);
          CustomAlert({
            title: "Error",
            text: "An error occurred while adding the request. Please try again later.",
            icon: "error",
            confirmButtonText: "Retry",
          });
        });
    }
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1031,
          }}
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content w-[1086px] rounded-[24px] p-6 bg-white border border-[rgba(0,0,0,0.175)]">
              <img
                src={LeftCircle}
                alt="leftImg"
                className="absolute left-0 bottom-0 w-[110px] h-[105px]"
              />
              <img
                src={RightCircle}
                alt="leftImg"
                className="absolute right-0 top-0 w-[110px] h-[105px]"
              />
              <div className="modal-header flex items-center justify-between border-b-0 mb-3">
                <div className="flex items-center">
                  <img
                    src={AddVectorIcon}
                    alt="Add Icon"
                    className="w-[43px] h-[38px] mr-2"
                  />
                  <h5 className="modal-title main-title">
                    {action === "add"
                      ? "Add"
                      : action === "modify"
                      ? "Modify"
                      : "View"}{" "}
                    Pickup Address
                  </h5>
                </div>
                <img
                  src={CrossIcon}
                  alt="filter icon"
                  className="w-[30px] h-[30px] cursor-pointer z-20"
                  onClick={handleBack}
                />
              </div>
              <form>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "24px",
                  }}
                >
                  <div className="row mt-2 w-full">
                    <div
                      className="scoped-modal modal-body"
                      style={{ paddingBlock: "0px" }}
                    >
                      {/* Row 1 */}
                      <div className="row mb-3">
                        <div className="col-md-4">
                          <div className="form-group relative">
                            <label htmlFor="addressTitle">
                              Address Title
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <div className="relative">
                              <i className="fa fa-tag absolute left-3 top-1/2 transform -translate-y-1/2 text-[#ff702b]"></i>
                              <input
                                type="text"
                                className="form-control w-full pl-10"
                                placeholder="Enter Address Title"
                                id="addressTitle"
                                value={formData.addressTitle}
                                onChange={handleInputChange}
                                onBlur={handleBlur}
                                disabled={isReadOnly}
                              />
                            </div>
                            {!isReadOnly && errors.addressTitle ? (
                              <span className="error">
                                {errors.addressTitle}
                              </span>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group relative">
                            <label htmlFor="addressee">
                              Addressee
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <div className="relative">
                              <i className="fa fa-user absolute left-3 top-1/2 transform -translate-y-1/2 text-[#ff702b]"></i>
                              <input
                                type="text"
                                className="form-control w-full pl-10"
                                placeholder="Enter Addressee"
                                id="addressee"
                                value={formData.addressee}
                                disabled={isReadOnly}
                                maxLength={50}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (/^[A-Za-z .'-]*$/.test(value)) {
                                    handleInputChange(e);
                                  }
                                }}
                                onBlur={handleBlur}
                              />
                            </div>
                            {!isReadOnly && errors.addressee ? (
                              <span className="error">{errors.addressee}</span>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group relative">
                            <label htmlFor="fullAddress">
                              Full Address
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <div className="relative">
                              <i className="fa fa-map-marker-alt absolute left-3 top-1/2 transform -translate-y-1/2 text-[#ff702b]"></i>
                              <input
                                type="text"
                                className="form-control w-full pl-10"
                                placeholder="Enter Full Address"
                                id="fullAddress"
                                value={formData.fullAddress}
                                disabled={isReadOnly}
                                onChange={handleInputChange}
                                onBlur={handleBlur}
                              />
                            </div>
                            {!isReadOnly && errors.fullAddress ? (
                              <span className="error">
                                {errors.fullAddress}
                              </span>
                            ) : null}
                          </div>
                        </div>
                      </div>

                      {/* Row 2 */}
                      <div className="row mb-3">
                        <div className="col-md-4">
                          <div className="form-group relative">
                            <label htmlFor="pinCode">
                              PIN Code
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <div className="relative">
                              <i className="fa fa-map-pin absolute left-3 top-1/2 transform -translate-y-1/2 text-[#ff702b]"></i>
                              <input
                                type="text"
                                className="form-control w-full pl-10"
                                placeholder="Enter PIN Code"
                                id="pinCode"
                                value={formData.pinCode}
                                disabled={isReadOnly}
                                maxLength={6}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (/^\d{0,6}$/.test(value)) {
                                    handleInputChange(e);
                                  }
                                }}
                                onBlur={handleBlur}
                              />
                            </div>
                            {!isReadOnly && errors.pinCode ? (
                              <span className="error">{errors.pinCode}</span>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group relative">
                            <label htmlFor="city">City</label>
                            <div className="relative">
                              <i className="fa fa-city absolute left-3 top-1/2 transform -translate-y-1/2 text-[#ff702b]"></i>
                              <input
                                type="text"
                                className="form-control w-full pl-10"
                                id="city"
                                value={formData.city || "City"}
                                style={{ cursor: "not-allowed" }}
                                readOnly
                              />
                            </div>
                            {!isReadOnly && errors.city ? (
                              <span className="error">{errors.city}</span>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group relative">
                            <label htmlFor="state">State</label>
                            <div className="relative">
                              <i className="fa fa-globe absolute left-3 top-1/2 transform -translate-y-1/2 text-[#ff702b]"></i>
                              <input
                                type="text"
                                className="form-control w-full pl-10"
                                id="state"
                                value={formData.state || "State"}
                                style={{ cursor: "not-allowed" }}
                                readOnly
                              />
                            </div>
                            {!isReadOnly && errors.state ? (
                              <span className="error">{errors.state}</span>
                            ) : null}
                          </div>
                        </div>
                      </div>

                      {/* Row 3 */}
                      <div className="row mb-3">
                        <div className="col-md-4">
                          <div className="form-group relative">
                            <label htmlFor="phone">
                              Mobile No.
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <div className="relative">
                              <i className="fa fa-phone absolute left-3 top-1/2 transform -translate-y-1/2 text-[#ff702b]"></i>
                              <input
                                type="text"
                                className="form-control w-full pl-10"
                                placeholder="Enter Mobile No."
                                id="phone"
                                value={formData.phone}
                                disabled={isReadOnly}
                                maxLength={10}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (/^\d{0,10}$/.test(value)) {
                                    handleInputChange(e);
                                  }
                                }}
                                onBlur={handleBlur}
                              />
                            </div>
                            {!isReadOnly && errors.phone ? (
                              <span className="error">{errors.phone}</span>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group relative">
                            <label htmlFor="email">
                              Email
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <div className="relative">
                              <i className="fa fa-envelope absolute left-3 top-1/2 transform -translate-y-1/2 text-[#ff702b]"></i>
                              <input
                                type="email"
                                className="form-control w-full pl-10"
                                placeholder="Enter Email"
                                id="email"
                                value={formData.email}
                                disabled={isReadOnly}
                                onChange={handleInputChange}
                                onBlur={handleBlur}
                              />
                            </div>
                            {!isReadOnly && errors.email ? (
                              <span className="error">{errors.email}</span>
                            ) : null}
                          </div>
                        </div>
                        {userProfile === "OPERATION" &&
                          (action === "modify" || action === "view") && (
                            <div className="col-md-4">
                              <div className="form-group relative">
                                <label htmlFor="optnAddressId">
                                  Address ID
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <div className="relative">
                                  <i className="fa fa-id-card absolute left-3 top-1/2 transform -translate-y-1/2 text-[#ff702b]"></i>
                                  <input
                                    type="text"
                                    className="form-control w-full pl-10"
                                    placeholder="Enter Address ID"
                                    id="optnAddressId"
                                    value={formData.optnAddressId}
                                    disabled={isReadOnly}
                                    onChange={handleInputChange}
                                    onBlur={handleBlur}
                                  />
                                </div>
                                {!isReadOnly && errors.optnAddressId ? (
                                  <span className="error">
                                    {errors.optnAddressId}
                                  </span>
                                ) : null}
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "12px",
                    paddingTop: "12px",
                    gap: "21px",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-back !rounded-[8px] w-[133px] h[33px]"
                    onClick={handleBack}
                  >
                    Cancel
                  </button>
                  {!isReadOnly && (action === "add" || action === "modify") && (
                    <button
                      type="button"
                      className="btn btn-submit !rounded-[8px] w-[133px] h[33px]"
                      onClick={handleAddPickupAddressModal}
                    >
                      {action === "modify" ? "Update" : "Submit"}
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddPickupAddressModal;
